import { render, staticRenderFns } from "./input-options.vue?vue&type=template&id=ddff575c&scoped=true&"
import script from "./input-options.vue?vue&type=script&lang=js&"
export * from "./input-options.vue?vue&type=script&lang=js&"
import style0 from "./input-options.vue?vue&type=style&index=0&id=ddff575c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddff575c",
  null
  
)

export default component.exports